import React, { useEffect, useState } from 'react'
import { Input, Modal, Select } from 'antd'
import styled from 'styled-components'
import {
  getVoidConsequencesCopy,
  GR_VOID_COPY,
  GR_VOID_REASONS,
} from 'src/utils/goodsReceiptingVoidHelpers'

const { TextArea } = Input
const { Option } = Select

/**
 * Chunk B2–B3 — Void PO confirm: reason required, note optional, consequences.
 * When an invoice is attached-only, copy mentions auto-unlink.
 */
const VoidOrderModal = ({
  visible,
  record,
  uploadedInvoices = [],
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const [reason, setReason] = useState('')
  const [note, setNote] = useState('')

  useEffect(() => {
    if (!visible) {
      setReason('')
      setNote('')
    }
  }, [visible])

  if (!record) return null

  const canSubmit = Boolean(String(reason || '').trim())
  const consequences = getVoidConsequencesCopy(record, uploadedInvoices)

  return (
    <StyledModal
      title={GR_VOID_COPY.modalTitle}
      visible={visible}
      onOk={() => onConfirm({ reason, note })}
      onCancel={onCancel}
      okText={GR_VOID_COPY.okText}
      cancelText='Cancel'
      okButtonProps={{ type: 'danger', loading, disabled: !canSubmit }}
      confirmLoading={loading}
      destroyOnClose
    >
      <OrderDetails>
        <DetailRow>Supplier: {record.supplier?.title || '—'}</DetailRow>
        <DetailRow>PO Number: {record.purchaseOrderNumber || '—'}</DetailRow>
      </OrderDetails>

      <FieldLabel>{GR_VOID_COPY.reasonLabel}</FieldLabel>
      <Select
        style={{ width: '100%', marginBottom: 12 }}
        placeholder='Select a reason'
        value={reason || undefined}
        onChange={setReason}
      >
        {GR_VOID_REASONS.map(item => (
          <Option key={item} value={item}>
            {item}
          </Option>
        ))}
      </Select>

      <FieldLabel>{GR_VOID_COPY.noteLabel}</FieldLabel>
      <TextArea
        rows={3}
        value={note}
        onChange={e => setNote(e.target.value)}
        placeholder='Optional details'
        style={{ marginBottom: 12 }}
      />

      <Consequences>{consequences}</Consequences>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }
`

const OrderDetails = styled.div`
  margin-bottom: 14px;
`

const DetailRow = styled.p`
  margin: 4px 0;
  color: #595959;
  font-size: 13px;
`

const FieldLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.85);
`

const Consequences = styled.p`
  margin: 0;
  padding: 10px 12px;
  border-radius: 6px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  font-size: 13px;
  line-height: 1.45;
  color: #ad6800;
`

export default VoidOrderModal
